import BaseModel from '@/shared/models/BaseModel'
import axios from '@/services/axios'

export default class Prize extends BaseModel {

    defaults() {
        return {
            id           : null,
            name         : null,
            description  : null,
            tos_url      : null,
            created_at   : null,
            updated_at   : null,
            expires_at   : null,
            expires_in   : null,
            withdrawn_at : null,
            value        : null,
            photo_url    : null,
            integrator_id: null,
            show_in_store: true,
        }
    }

    static async list() {
        const response = await axios({
            url: '/prize',
            method: 'get',
            params: {
                store: 'list_store',
            }
        })

        if (!response || !response.data || response.status !== 200)
            return

        return response.data.map(level => new this(level))
    }
}